import { useMemo, useState } from "react";// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Pie } from "react-chartjs-2";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// PieChart configurations
import configs from "examples/Charts/PieChart/configs";
import ApnaSelect from "components/ApnaSelect";
import { useSelector } from "react-redux";

function PieChart({ title, description, height, chart, option, handleFilterChangePieChart, value , handelOnClickPieChart }) {
   const userTheme = useSelector((state) => state.commonSlice.theme);
  const { data, options } = configs(chart.labels || [], chart.datasets || {});

  const renderChart = (
    <SoftBox p={2}>

      <SoftBox display="flex" justifyContent="space-between" alignItems="center">
        <SoftBox>
          {title || description ? (
            <SoftBox px={description ? 1 : 0} pt={description ? 1 : 0}>
              {title && (
                <SoftBox mb={1}>
                  <SoftTypography variant="h6">{title}</SoftTypography>
                </SoftBox>
              )}
              <SoftBox mb={4}>
                <SoftTypography component="div" variant="button" fontWeight="regular" color="text">
                  {description}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          ) : null}
        </SoftBox>

        <SoftBox>
          <ApnaSelect
            value={value}
            options={option}
            onChange={(event) => handleFilterChangePieChart(event.target.value)}
          />
        </SoftBox>

      </SoftBox>

      {useMemo(
        () => (
          <SoftBox height={height}>
            <Pie data={data} options={options}
            getElementAtEvent={(element) => (element&&handelOnClickPieChart(element[0]?.index))}
            />
          </SoftBox>
        ),
        [chart, height]
      )}
    </SoftBox>
  );

  return title || description ? <Card className="glassmorphism-card">{renderChart}</Card> : renderChart;
}

// Setting default values for the props of PieChart
PieChart.defaultProps = {
  title: "",
  description: "",
  height: "19.125rem",
};

// Typechecking props for the PieChart
PieChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chart: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.object])).isRequired,
};

export default PieChart;
